import { useMemo } from "react";
import { SpillInputData } from "./entity";
import styled from "@emotion/styled";
import { css } from "@emotion/css";
import { Text, View } from "@react-pdf/renderer";
import { pdfStyle } from "./pdfStyle";
import { Image } from "@react-pdf/renderer";

const BoardTable = styled.table<{ selected?: boolean }>`
  border: 1px solid #333333;
  width: var(--bridge-spill-board-width);
  height: var(--bridge-spill-board-width);

  background-repeat: no-repeat;
  background-size: contain;

  td {
    width: 33.33%;
    text-align: center;
  }
`;

const BoardContainer = styled.div`
  --bridge-spill-board-width: 130px;
  position: relative;
`;

const BoardText = styled.span<{ isGiver?: boolean; isZone?: boolean }>`
  font-weight: bold;
  ${(props) => (props.isZone ? { color: "white" } : {})};
  font-size: 18px;
  ${(props) =>
    props.isGiver
      ? {
          background: "black",
          display: "inline-block",
          borderRadius: "50%",
          width: 24,
          lineHeight: "24px",
          color: "white",
        }
      : {}}
`;

const BoardNo = styled.span`
  text-align: center;
  background: white;
  outline: 1px solid black;
  border-radius: 50%;
  width: 40px;
  line-height: 40px;
  font-weight: bold;
  display: inline-block;
`;

export const PdfBoard = (props: {
  isGiver: boolean;
  isZone: boolean;
  text: string;
}) => {
  let s: any = {
    fontSize: 10,
    textAlign: "center",
  };
  if (props.isGiver) {
    s = {
      ...s,
      backgroundColor: "black",
      color: "white",
      borderRadius: 40,
      paddingTop: 4,
      width: 18,
      height: 18,
    };
  }
  if (props.isZone) {
    s = {
      ...s,
      color: "white",
    };
  }
  return <Text style={s}>{props.text}</Text>;
};

export const Board = (props: {
  editMode?: boolean;
  zone: SpillInputData["zone"];
  giver: SpillInputData["giver"];
  boardNo: string;
  onBoardNoChange: (v: string) => void;
  pdf?: boolean;
}) => {
  const { giver, zone, editMode } = props;
  const bg = useMemo(() => {
    return "/images/board-bg-" + zone + ".png";
  }, [zone]);

  const pdfWidth = 90;

  if (props.pdf) {
    return (
      <View style={{ width: pdfWidth }}>
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: pdfWidth,
            height: pdfWidth,
          }}
        >
          <Image src={bg} style={{ width: pdfWidth, height: pdfWidth }} />
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            width: pdfWidth,
            height: pdfWidth / 3,
          }}
        >
          <View style={pdfStyle.cell}>
            <Text></Text>
          </View>
          <View style={{ ...pdfStyle.cell, paddingLeft: 8, paddingTop: 5 }}>
            <PdfBoard
              isGiver={giver === "n"}
              isZone={zone === "a" || zone === "ns"}
              text="N"
            />
          </View>
          <View style={pdfStyle.cell}>
            <Text></Text>
          </View>
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            width: pdfWidth,
            height: pdfWidth / 3,
          }}
        >
          <View style={pdfStyle.cell}>
            <PdfBoard
              isGiver={giver === "w"}
              isZone={zone === "a" || zone === "ew"}
              text="V"
            />
          </View>
          <View style={pdfStyle.cell}>
            <Text></Text>
          </View>
          <View style={pdfStyle.cell}>
            <PdfBoard
              isGiver={giver === "e"}
              isZone={zone === "a" || zone === "ew"}
              text="Ø"
            />
          </View>
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            width: pdfWidth,
            height: pdfWidth / 3,
          }}
        >
          <View style={pdfStyle.cell}>
            <Text></Text>
          </View>
          <View style={pdfStyle.cell}>
            <PdfBoard
              isGiver={giver === "s"}
              isZone={zone === "a" || zone === "ns"}
              text="S"
            />
          </View>
          <View style={pdfStyle.cell}>
            <Text></Text>
          </View>
        </View>
      </View>
    );
  }

  return (
    <BoardContainer>
      <BoardTable style={{ backgroundImage: "url(" + bg + ")" }}>
        <tr>
          <td></td>
          <td>
            <BoardText
              isGiver={giver === "n"}
              isZone={zone === "a" || zone === "ns"}
            >
              N
            </BoardText>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <BoardText
              isGiver={giver === "w"}
              isZone={zone === "a" || zone === "ew"}
            >
              V
            </BoardText>
          </td>
          <td>
            {editMode && (
              <BoardNo>
                <input
                  value={props.boardNo}
                  placeholder="X"
                  onChange={(e) => props.onBoardNoChange(e.target.value)}
                  className={css`
                    width: 1.5rem;
                    text-align: center;
                    height: 1.5rem;
                    border: 1px solid #cccccc;
                  `}
                />
              </BoardNo>
            )}
            {!editMode && props.boardNo && <BoardNo>{props.boardNo}</BoardNo>}
          </td>
          <td>
            <BoardText
              isGiver={giver === "e"}
              isZone={zone === "a" || zone === "ew"}
            >
              Ø
            </BoardText>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <BoardText
              isGiver={giver === "s"}
              isZone={zone === "a" || zone === "ns"}
            >
              S
            </BoardText>
          </td>
          <td></td>
        </tr>
      </BoardTable>
    </BoardContainer>
  );
};
